<template>
  <div :class="$style.wrapper">
    <div :class="$style.container">
      <div :class="$style.header">
        <div :class="$style.title">
          <h2>Нераспознанные платежи ({{ totalPayments }})</h2>
          <p v-if="file" :class="$style.file" :title="file.name">В файле {{ file.name }}</p>
        </div>
        <div :class="$style.headerAside">
          <elsa-v-datepicker
            label="Дата операции"
            class="mr-2"
            v-model="filter.date"
          />
          <form @submit.prevent="onApplyFilterSearch">
            <vs-input
              label="Поиск"
              class="mr-2"
              v-model="searchQuery"
            />
          </form>
          <vs-button :disabled="!payments.length" class="mr-2" button="button" type="border" @click="selectAll">
            Выделить все
          </vs-button>
          <vs-button :disabled="!payments.length" button="button" color="danger" type="border" @click="deleteAll">
            Удалить выделенные ({{ paymentsSelected.length }})
          </vs-button>
        </div>
      </div>

      <vue-perfect-scrollbar @ps-y-reach-end="scrolledBottom">
        <template v-if="payments.length || paymentLoading">
          <unresolved-payment
            class="vx-col w-full mb-base"
            v-for="(payment, index) in payments"
            :key="payment.id"
            :payment="payment"
            :zIndex="(payments.length-index)+1"
            :houses="houses"
            :apartments="apartments"
            @changeHouse="updateAparts"
            :index="index"
            :selected.sync="paymentsSelected"
            @resolve="resolvePayment($event, index)"
            @delete="deletePayment(payment, index)"
          />
          <div class="employee-unresolved-payments__loading" v-if="paymentLoading">
            <div class="block-loading" />
            <div class="employee-unresolved-payments__loading-text">Получаю платежи</div>
          </div>
        </template>
        <h3 class="w-full text-center" v-else>Нераспознанных платежей нет</h3>
      </vue-perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import UnresolvedPayment   from "@/components/calculated-program/unresolved-payments/UnresolvedPayment";
import formatDate          from "@/client/helpers/formatDate";
import dateParse           from "date-fns/parse";
import notifyHttpError     from "@/mixins/notifyHttpError";
import stringify           from "qs/lib/stringify";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import _isEqual            from 'lodash/isEqual';

export default {
  name:       "UnresolvedPayments",
  components: { UnresolvedPayment, VuePerfectScrollbar },
  mixins:     [notifyHttpError],
  data:       () => ({
    filter:            {
      search: null,
      date:   null,
      fileId: null,
    },
    searchQuery:       '',
    lastAppliedFilter: '',
    file:              null,

    apartments:        {},
    isPaymentsLoading: true,
    payments:          [],
    paymentsSelected:  [],
    wasSidebarOpen:    null,
    currentPage:       1,
    totalPages:        1,
    totalPayments:     0,
    paymentLoading:    false,
    searchError:       false,
  }),
  computed:   {
    houses() {
      return this.$store.getters['appUser/houses'];
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:    {
    onApplyFilterSearch() {
      this.filter.search = this.searchQuery;
    },

    parseQuery() {
      const { query } = this.$route;
      this.searchQuery = query.search || '';
      this.filter = {
        date:   query.date ? dateParse(query.date, 'dd.MM.yyyy', new Date()) : null,
        search: query.search || null,
        fileId: query.fileId || null,
      };
      this.lastAppliedFilter = { ...this.filter };
      this.initPayments();
    },

    updateAparts( id ) {
      if (id === null || (this.apartments.hasOwnProperty(id) && this.apartments[id].length)) {
        return false;
      } else {
        this.$set(this.apartments, id, 0);
        this.getAparts(id);
      }
    },

    getAparts( id ) {
      return this.$http.get(`all_aparts?buildings_id=${id}`).then(
        ( { data } ) => this.$set(this.apartments, id, data),
        () => this.$set(this.apartments, id, []),
      );
    },

    async resolvePayment( payload, index ) {
      try {
        let body = Object.assign(payload, { users_id: this.$store.getters['appUser/id'] });
        this.$http.post('unresolved_invoices', body);
        this.deletePaymentByIndex(index);
        this.$vs.notify({ color: 'success', title: 'Успешно', text: 'Платеж разнесен' });
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },

    async deletePayment( payment, index, deleteLocal = true, withNotify = true ) {
      try {
        await this.$http.delete('unresolved_invoices/' + payment.id, {
          params: {
            invoice_id:   payment.id,
            buildings_id: this.selectedHouseId,
          },
        });
        if (deleteLocal) {
          this.deletePaymentByIndex(index);
        }

        if (withNotify) {
          this.$vs.notify({ color: 'success', title: 'Успешное удаление', text: 'Платеж удален' });
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },

    deletePaymentByIndex( index ) {
      // let paymentIndex = this.payments[index];
      this.payments.splice(index, 1);
    },

    deleteAll() {
      if (!this.paymentsSelected.length) return false;
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите удалить выделенные?',
        acceptText: 'Удалить',
        cancelText: 'Отменить',
        accept:     async () => {
          for await (let paymentIndex of this.paymentsSelected) {
            if (this.payments[paymentIndex]) {
              this.deletePayment(this.payments[paymentIndex], paymentIndex, false, false);
            }
          }
          this.$vs.notify({ color: 'success', title: 'Успешное удаление', text: 'Платежи удалены' });
          this.initPayments();
        },
      });
    },

    getPayments( page = 1 ) {
      const { date, search, fileId } = this.filter;
      const filters = [];
      if (date) filters.push(['date', 'equals', formatDate(date, 'yyyy-MM-dd')]);
      if (fileId) filters.push(['files_id', 'equals', fileId]);

      return this.$http.get('unresolved_invoices', {
        params:           {
          buildings_id: this.selectedHouseId,
          page:         page,
          per_page:     50,
          search,
          filters,
        },
        paramsSerializer: ( params ) => stringify(params),
      }).then(
        ( { data } ) => {
          this.totalPages = data.last_page;
          this.totalPayments = data.total;
          return data.data;
        },
        this.notifyHttpError,
      );
    },

    loadFile() {
      const { fileId } = this.filter;
      if (!fileId) return;
      this.$http.get(`file/${fileId}`, { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.file = data;
      });
    },

    selectAll() {
      this.paymentsSelected = [];
      for (let i = 0; i < this.payments.length; i++) {
        this.paymentsSelected.push(i);
      }
    },

    initPayments() {
      this.paymentLoading = true;
      this.payments = [];
      this.paymentsSelected = [];
      this.totalPages = 1;
      this.currentPage = 1;
      this.$nextTick(async () => {
        this.payments = await this.getPayments(this.currentPage);
        this.paymentLoading = false;
      });
    },

    async getNextPagePayments() {
      this.paymentLoading = true;
      this.currentPage += 1;
      let payments = await this.getPayments(this.currentPage);
      this.payments.push(...payments);
      this.paymentLoading = false;
    },

    scrolledBottom( event ) {
      event.preventDefault();
      if (this.paymentLoading || this.issuesPageLoading) return false;
      if (this.currentPage + 1 <= this.totalPages) {
        this.getNextPagePayments();
      }
    },
  },
  created() {
    this.parseQuery();
    this.loadFile();
  },

  watch: {
    '$route.query'() {
      this.parseQuery();
    },

    filter: {
      deep: true,
      handler( filter ) {
        const query = {};
        if (_isEqual(this.lastAppliedFilter, filter)) return;
        if (filter.fileId) query.fileId = filter.fileId;
        if (filter.date) query.date = formatDate(filter.date);
        if (filter.search) query.search = filter.search.trim();
        this.$router.push({ query });
        this.lastAppliedFilter = { ...filter };
      },
    },
  },
};
</script>

<style lang="scss" module>
:global {
  .block-loading {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: '';
      display: inline-block;
      width: 50px;
      height: 50px;
      border: 3px solid rgba(var(--vs-primary), 1);
      border-radius: 50%;
      border-top-color: #eee;
      animation: spin 1s ease-in-out infinite;
    }
  }
}

.wrapper {
  flex: 1;
  position: relative;
}

.container {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}

.header {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  @include max-width(1300px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.title {
  margin-right: auto;
}

.file {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.headerAside {
  //margin-left: auto;
  //flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  @include max-width(1300px) {
    width: 100%;
    justify-content: flex-start;
    margin-top: 1em;
  }
}

.search {
  max-width: 350px;
  margin-right: .5em;
}

.buttons {
  margin-top: 11px;
}
</style>
